<template>
	<tr>
		<td width="10%" class="px-2 py-4 whitespace-nowrap text-gray-500">
			<span class="font-bold">{{ bid.qty.mt }} t</span>, ca.
		</td>
		<td width="18%" class="pl-2 pr-2 py-4 font-medium text-gray-900 leading-5">
			{{
				$cropOptions.getLocalizedLabel(
					bid.product.grade,
					$cropOptions.productGradeOptions
				)
			}}
			<span class="text-sm text-gray-500 whitespace-nowrap"
				>{{ bid.product.origin }} {{ bid.product.harvest || __("n.a.") }}</span
			>
		</td>
		<td width="18%" class="px-2 py-4 text-gray-500 text-sm xl:text-base">
			{{ $cropOptions.dateToString(bid, locale, true) }}
		</td>
		<td width="18%" class="px-2 py-4 whitespace-nowrap text-gray-500">
			{{
				$cropOptions.getLocalizedLabel(
					bid.location.mode,
					$cropOptions.locationModeOptions
				)
			}}
			{{ bid.location.address.zip }}
			{{ bid.location.address.city }}
		</td>
		<td width="18%" class="px-2 py-4 whitespace-nowrap text-gray-500">
			<span v-if="type == 'win'"> {{ bid.winning.price_mt }} &euro;/t </span>
			<span v-else> {{ bid.price.mt }} &euro;/t </span>
		</td>
		<td
			width="18%"
			class="px-2 py-4 whitespace-nowrap text-gray-500"
			:class="type !== 'loss' ? 'text-right' : ''"
		>
			<ui-button
				type="primary"
				v-if="type !== 'loss'"
				v-on:click="$inertia.get(threadLink)"
				:label="type == 'win' ? 'Zum Kontrakt' : 'Zur Verhandlung'"
			></ui-button>
			<span v-else-if="bid.winning.price_mt" class="font-bold"
				>{{ bid.winning.price_mt }} &euro;/t
				<ui-icon
					v-if="bid.is_traded"
					fill="text-gray-500"
					fa-class="fa-2x"
					name="fa-handshake"
					class="inline pl-4"
				/>
			</span>

			<span v-else class="font-bold">{{ __("keiner") }}</span>
		</td>
	</tr>
</template>

<script>
export default {
	props: {
		bid: {
			type: Object,
			required: true,
		},
		idx: {
			type: Number,
			required: true,
		},
		type: {
			type: String,
			required: true,
		},
	},
	data() {
		return {};
	},
	computed: {
		threadLink() {
			return this.$route("threads", { active_id: this.bid.thread_id });
		},
	},

	methods: {},
};
</script>
